import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=6898cce8&scoped=true&lang=html&"
import script from "./PageNotFound.vue?vue&type=script&lang=js&"
export * from "./PageNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6898cce8",
  null
  
)

export default component.exports